import {
  requestJson,
} from '../../../shared/api/apiClient';


const MEMBER_ENDPOINT =
  '/api/profile/member';

const COMPANY_ENDPOINT =
  '/api/profile/company';

const SALES_REPRESENTATIVE_ENDPOINT =
  '/api/profile/sales-representative';

const VERIFY_PASSWORD_ENDPOINT =
  '/api/profile/verifypassword';

const SALES_REPRESENTATIVE_OPTIONS_ENDPOINT =
  '/api/signup/salesRepresentatives';

const CHANGE_PASSWORD_ENDPOINT =
  '/api/profile/changepassword';

function extractData(
  response,
) {
  if (
    response &&
    typeof response === 'object' &&
    response.data !== undefined
  ) {
    return response.data;
  }

  return null;
}


export async function getMemberInfo() {
  const response =
    await requestJson(
      MEMBER_ENDPOINT,
      {
        method:
          'GET',
      },
    );

  return extractData(
    response,
  );
}


export async function getCompanyInfo() {
  const response =
    await requestJson(
      COMPANY_ENDPOINT,
      {
        method:
          'GET',
      },
    );

  return extractData(
    response,
  );
}


export async function getSalesRepresentative() {
  const response =
    await requestJson(
      SALES_REPRESENTATIVE_ENDPOINT,
      {
        method:
          'GET',
      },
    );

  return extractData(
    response,
  );
}


export async function getSalesRepresentativeOptions() {
  const response =
    await requestJson(
      SALES_REPRESENTATIVE_OPTIONS_ENDPOINT,
      {
        method:
          'GET',
      },
    );

  const data =
    extractData(
      response,
    );

  return Array.isArray(
    data,
  )
    ? data
    : [];
}


export async function verifyCurrentPassword(
  password,
) {
  const response =
    await fetch(
      VERIFY_PASSWORD_ENDPOINT,
      {
        method:
          'POST',

        credentials:
          'include',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            password,
          }),
      },
    );

  if (
    response.status === 400 ||
    response.status === 401 ||
    response.status === 403
  ) {
    return false;
  }

  if (
    !response.ok
  ) {
    throw new Error(
      'PASSWORD_VERIFY_FAILED',
    );
  }

  return true;
}


export async function updateCompanyInfo(
  data,
) {
  const response =
    await requestJson(
      COMPANY_ENDPOINT,
      {
        method:
          'PATCH',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify(
            data,
          ),
      },
    );

  return extractData(
    response,
  );
}


export async function getMemberInfoProfileBundle() {
  const [
    member,
    company,
    salesRepresentative,
  ] =
    await Promise.all([
      getMemberInfo(),
      getCompanyInfo(),
      getSalesRepresentative(),
    ]);

  return {
    member,
    company,
    salesRepresentative,
  };
}
export async function changePassword({
  currentPassword,
  newPassword,
}) {
  const response =
    await requestJson(
      CHANGE_PASSWORD_ENDPOINT,
      {
        method:
          'POST',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            currentPassword,
            newPassword,
          }),
      },
    );

  return extractData(
    response,
  );
}